<template>
  <div id="app" style="background-color: #F0F2F5;">
    <router-view v-if="showRouter"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        showRouter: true
      }
    },
    methods: {
      reload() {
        this.showRouter = false
        this.$nextTick(function() {
          this.showRouter = true
        })
      }
    }
  }
</script>

<style>
  @import "./assets/css/common.less";

  ::-webkit-scrollbar {
/*    border-radius: 10px 10px 10px 10px;
    background-color: #8B8B8B;
    height: 7px; */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue